import React from "react";
import {useEffect, useState} from "react";
function Index() {
    const [data, setData] = useState([]);
    
    useEffect(() => {
        fetch("https://dharatiengineering.in/ad_dharati/Api/Slider/").then((res) => {
            return res.json();
        }).then((res) => {
            setData(res.data);
            console.log(res);
        });
    }, []);

    const indexslider = data.map((ins) => {
        return (
            <>
                <div>
                    <div className="carousel-inner">
                            <div className="carousel-item">
                                <img src={"https://dharatiengineering.in/ad_dharati/Images/slider/"+ins.Image}
                                    className="d-block w-100"
                                    alt="slide 1"/>
                            </div>
                    </div>
                </div>
            </>
        );
    });

   

  return (
       
        <> 
            <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">
        <div className="carousel-indicators">
          <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
          <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
          <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
        </div>
        <div className="carousel-inner">
          <div className="carousel-item active">
            <img src="img/slider/carousel-1.jpg" className="d-block w-100"  alt='slide 1'/>
          </div>
          <div className="carousel-item">
            <img src="img/slider/carousel-2.jpg" className="d-block w-100" alt='slide 2'/>
          </div>
          <div className="carousel-item">
            <img src="img/slider/carousel-3.jpg" className="d-block w-100" alt='slide 3'/>
          </div>
        </div>
        <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
            <div className="container-fluid bg-light overflow-hidden my-5 px-lg-0">
                <div className="container about px-lg-0">
                    <div className="row g-0 mx-lg-0">
                        <div className="col-lg-6 ps-lg-0 reactabout1">
                            <div className="position-relative h-100">
                                <img className="position-absolute img-fluid w-100 h-70 reactabout2" src="img/Gif/gif.gif" alt=""/>
                            </div>
                        </div>
                        <div className="col-lg-6 about-text py-5 wow fadeIn" data-wow-delay="0.5s">
                            <div className="p-lg-5 pe-lg-0">
                                <div className="section-title text-start">
                                    <h1 className="display-5 mb-4">About Us</h1>
                                </div>
                                <p className="mb-4 pb-2">
                                    Dharati Engineering Was Established In The Year 2010 In Morbi
                                                      Town By Amarshibhai Who Have Nearly 15 Years Of Experience In
                                                      The Field Of Reverse Engineering,Product Design,mould And Die
                                                      Design.aiming To Cater To The Fast Growing Plastic ,the
                                                      Services Started With Product Design And Mould Design For
                                                      Clock Industries In Morbi And Went On To Expanding Its Base To
                                                      Ceramic Design,ceramic Die Manufacturing,reverse
                                                      Engineering,product Design And Mould Design Of Kitchen
                                                      Wares,bath Wares,electricals And Many More.
                                </p>
                                <div className="row g-4 mb-4 pb-2"></div>
                                <a href="about.html" className="btn  py-3 px-5">
                                    Explore More
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
         
    );
}
export default Index;